const dietsFAQ = [
  {
    id: 1,
    question: "نوع غذا ها در برنامه به چه صورت است؟",
    answer: [
      "برنامه غذایی برحسب غذای سفره تنظیم می‌شود میزان دریافت کالری، کربوهیدرات، پروتئین و چربی بر اساس نیاز بدن شما تعیین می‌گردد. پس از مدتی با صلاح دید مربی و شرایط شما، بر اساس هدف شما برنامه غذایی به یک برنامه اصولی تر از غذای سفره به غذای رژیمی ورزشی تغییر می‌کند. "
    ]
  },
  {
    id: 2,
    question: "برنامه غذایی چه کمکی به ما می‌کند؟",
    answer: [
      "برنامه غذایی سالم و اصولی علاوه بر تناسب اندام مزایای ویژه ای رو برای شما به همراه خواهد داشت. تغذیه سالم، مکمل بهتر درک کردن جهان ماست، سلامت جسم و ذهن خود را با تغذیه سالم و اصولی تضمین می‌کنید."
    ]
  },
  {
    id: 3,
    question: "پشتیبانی تغذیه چیست؟",
    answer: [
      "با پشتیبانی در طرح تغذیه، میتوانید روزانه برنامه غذایی خود را در اپلیکیشن وارد نمایید، مربی هر شب برنامه غذایی روز شما رو چک میکند و به شما بازخورد میدهد، راهنمایی های لازم به جهت اصلاح برنامه غذایی و گرفتن نتیجه بهتر به شما داده خواهد شد."
    ]
  },
  {
    id: 4,
    question: "چند وقت یکبار برنامه دریافت کنیم؟",
    answer: [
      "بعد ار دریافت برنامه غذایی، مادامی که کاهش وزن دارید، نیلز به تغییر یا دریافت برنامه جدید نیست. طی پشتیبانی ، نکات ضروری در تغذیه به شما آموزش داده خواهد شد."
    ]
  }
];

export default dietsFAQ;